<template>
  <!-- `persistent` : le traitement enchaîne des appels serveur qu'on ne sait pas interrompre
       proprement. Fermer la modale laisserait le lot se poursuivre à l'insu de l'utilisateur. -->
  <v-dialog :model-value="visible" :width="440" persistent>
    <v-card class="pa-5">
      <div class="progression-titre pb-4">{{ libelle }}</div>
      <v-progress-linear
:model-value="pourcentage"
                         color="secondary"
                         height="8"
                         rounded>
      </v-progress-linear>
      <div class="progression-compteur pt-3">{{ compteur }}</div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  /**
   * Modale bloquante d'avancement pour un traitement de masse.
   *
   * Volontairement générique (aucune notion de DPAE) : les autres actions de masse de la barre de
   * sélection la réutiliseront. `LoadProgress.vue` du framework ne pouvait pas servir ici — sa barre
   * est indéterminée, sans valeur ni compteur, et elle occupe 100vh au lieu de se superposer.
   *
   * Composant purement présentationnel : il n'émet rien, la fermeture est pilotée par le parent via
   * `visible`.
   */
  export default defineComponent({
    name: 'SectionProgressionMasse',
    props: {
      visible: {
        type: Boolean,
        required: false,
      },
      /** Nombre d'éléments déjà traités. */
      traites: {
        type: Number,
        required: true,
      },
      /** Nombre total d'éléments à traiter. */
      total: {
        type: Number,
        required: true,
      },
      libelle: {
        type: String,
        required: false,
        default: 'Traitement en cours',
      },
      /** Nom de l'unité traitée, pour le compteur (« 3 / 12 DPAE traitées »). */
      unite: {
        type: String,
        required: false,
        default: '',
      },
      /** Participe accordé à l'unité : « traitées » pour des DPAE, « traités » pour des contrats. */
      participe: {
        type: String,
        required: false,
        default: 'traitées',
      },
    },
    computed: {
      pourcentage (): number {
        if (this.total <= 0) return 0;
        return Math.round((this.traites / this.total) * 100);
      },
      compteur (): string {
        const suffixe = this.unite ? ` ${this.unite}` : '';
        return `${this.traites} / ${this.total}${suffixe} ${this.participe}`;
      },
    },
  });
</script>

<style scoped>
  .progression-titre {
    font-size: 16px;
    font-weight: 600;
    color: #135253;
    text-align: center;
  }

  .progression-compteur {
    font-size: 14px;
    color: #5B6A71;
    text-align: center;
  }
</style>
